import styled from 'styled-components';

export const HeaderMainTitleContainer = styled.div`
  @media (min-width: 960px) {
    & > div {
      width: ${(props) => props.theme.titleWidth};
      height: 100%;
      padding: 0px 20px;
      justify-content: center;
      align-items: center;
      display: flex;
      box-shadow: ${(props) => props.theme.titleBoxColor};
    }
  }

  @media (max-width: 960px) {
    & > div {
      height: 100%;
      width: ${(props) => props.theme.titleWidth};
      justify-content: center;
      align-items: center;
      display: flex;
      box-shadow: ${(props) => props.theme.titleBoxColor};
    }
  }

  & > div > span {
    width: 600px;
    color: ${(props) => props.theme.titleColor};
    font-size: ${(props) => props.theme.titleFontSize};
    text-align: center;
    -webkit-text-stroke: ${(props) => props.theme.titleStroke};
  }
`;
